<template>
  <div id="page-groupSpec">
    <Row class="main" :gutter="16">
      <Col span="5">
        <myaside ref="asideBar" @handleSelectTask="handleSelectTask"></myaside>
      </Col>
      <Col span="19" id="rightSide">
        <!-- 操作模块----------------------------------------------------------------------------->
        <div class="content-up">
          <!-- 发布时间 ----------------------------------------------------------->
          <Row class="row-launchDate">
            <Col span="3" style="text-align: right">
              <span class="option-title">发布时间</span>
            </Col>
            <Col span="21">
              <ul class="buttonGroup">
                <li
                  class="buttonGroup-item"
                  :class="{'active':timeSelected===1?true:false}"
                  @click="handleSelectLanchDate(1)"
                >今天</li>
                <li
                  class="buttonGroup-item"
                  :class="{'active':timeSelected===3?true:false}"
                  @click="handleSelectLanchDate(3)"
                >近3天</li>
                <li
                  class="buttonGroup-item"
                  :class="{'active':timeSelected===7?true:false}"
                  @click="handleSelectLanchDate(7)"
                >近7天</li>
                <li
                  class="buttonGroup-item"
                  :class="{'active':timeSelected===30?true:false}"
                  @click="handleSelectLanchDate(30)"
                >近30天</li>
                <li
                  class="buttonGroup-item"
                  :class="{'active':timeSelected==='custom'?true:false}"
                  @click="handleSelectLanchDate('custom')"
                >自定义</li>
              </ul>
              <DatePicker
                type="daterange"
                @on-ok="confirmDatePicker"
                v-model="dateRange"
                placement="bottom-end"
                placeholder="请选择日期范围"
                style="width: 200px;"
                confirm
                class="datePicker"
                v-show="isShowDatePicker"
                split-panels
              ></DatePicker>
            </Col>
          </Row>
          <!-- 情感分类 ----------------------------------------------------------->
          <Row class="row-sentimentClassify" style="margin-top:23px">
            <Col span="3" style="text-align: right">
              <span class="option-title">情感分类</span>
            </Col>
            <Col span="21">
              <ul class="buttonGroup">
                <li
                  class="buttonGroup-item"
                  :class="{'active':queryData.feeling===''?true:false}"
                  @click="handleSelectSentiment('')"
                >全部</li>
                <li
                  class="buttonGroup-item"
                  :class="{'active':queryData.feeling===1?true:false}"
                  @click="handleSelectSentiment(1)"
                >负面</li>
                <li
                  class="buttonGroup-item"
                  :class="{'active':queryData.feeling===0?true:false}"
                  @click="handleSelectSentiment(0)"
                >非负面</li>
              </ul>
            </Col>
          </Row>
          <!-- 预警分类---------------------------------------------------------->
          <Row class="row-sentimentClassify" style="margin-top:23px">
            <Col span="3" style="text-align: right">
              <span class="option-title">预警分类</span>
            </Col>
            <Col span="21">
              <ul class="buttonGroup">
                <li
                    class="buttonGroup-item"
                    :class="{'active':queryData.isWarn===1?true:false}"
                    @click="handleSelectIsWarn(1)"
                >全部</li>
                <li
                    class="buttonGroup-item"
                    :class="{'active':queryData.isWarn===0?true:false}"
                    @click="handleSelectIsWarn(0)"
                >预警</li>
              </ul>
            </Col>
          </Row>
          <!-- 关键词 ----------------------------------------------------------->
          <Row class="row-keyWords" style="margin-top:23px">
            <Col span="3" style="text-align: right">
              <span class="option-title">关键词</span>
            </Col>
            <Col span="21">
              <Input
                v-model="queryData.keyWords"
                search
                @on-search="searchByKeyWords"
                icon="ios-search-outline"
                placeholder="多个关键词请用逗号分隔"
                style="width: 317px"
                class="input-search"
              />
            </Col>
          </Row>
          <!-- 群号/名称 ----------------------------------------------------------->
          <Row class="row-groupNumOrName" style="margin-top:23px">
            <Col span="3" style="text-align: right">
              <span class="option-title">群组名称</span>
            </Col>
            <Col span="21">
              <Input
                v-model="queryData.groupName"
                search
                @on-search="searchByGroupNumOrName"
                icon="ios-search-outline"
                placeholder="结果内搜索"
                style="width: 317px"
                class="input-search"
              />
            </Col>
          </Row>
        </div>
        <!-- 消息列表----------------------------------------------------------------------------->
        <div class="content-down">
          <div class="tab-header" :class="{'tab-header-stick':isTabHeaderStick}">
            <span
              class="tab-title"
              :class="{'tab-title-selected':isShowContentMsgList&&enable_list,'disabled':!enable_list}"
              @click="changeView(0)"
            >消息列表</span>
            <span
              class="tab-title"
              :class="{'tab-title-selected':!isShowContentMsgList&&enable_analyze,'disabled':!enable_analyze}"
              @click="changeView(1)"
            >快速分析</span>
            <div class="dataNum-wrapper">
              <Tag color="black" class="tag-dataNum">总量：{{dataNum.total}}</Tag>
              <Tag color="#B23AEE" class="tag-dataNum">预警量：{{dataNum.warning}}</Tag>
              <Tag color="success" class="tag-dataNum" v-show="queryData.isWarn === 0">预警-非负面：{{dataNum.positive}}</Tag>
              <Tag color="error" class="tag-dataNum" v-show="queryData.isWarn === 0">预警-负面：{{dataNum.negative}}</Tag>
            </div>
          </div>
          <div
            class="tab-header-placeholder"
            :class="{'tab-header-placeholder-active':isTabHeaderStick}"
          ></div>
          <!-- 舆情列表 ------------------------------------------------------------------------------------------->
          <div class="tab-main tab-main-msgList" v-show="isShowContentMsgList">
            <div class="tab-content">
              <div class="tip" v-show="isShowTip" @click="handleClickTip">
                <p>截止到{{tipInfo.currentDate}} {{tipInfo.currentTime}}，又抓取到{{tipInfo.newDataNum}}条新数据，点击刷新数据列表</p>
              </div>
              <div class="listMessage-wrapper">
                <ul class="listMessage">
                  <li class="listMessage-item" v-for="(item,index) in listMessage" :key="item.id">
                    <div class="ls">
                      <Tag
                        :color="item.propertyColor"
                        class="tag-property"
                        style="width:56px; line-height:23px"
                      >{{item.propertyLabel}}</Tag>
                      <Icon type="ios-star" color="orange" size="24" v-if="item.followed" style="cursor: pointer;" @click="cancelFlowMeaasge(index,item.index_id)"/>
                      <Icon type="ios-star-outline" color="orange" size="24" style="cursor: pointer;" v-else @click="flowMessage(index,item.index_id)"/>
                    </div>
                    <div class="rs">
                      <div class="message-title">
                        <Icon type="ios-person-add" color="orange" size="24" v-if="item.senderFollwoed" style="cursor: pointer;" @click="cancelFollowSender(index, item.index_id)"/>
                        <Icon type="ios-person-add-outline" color="orange" size="24" style="cursor: pointer;" v-else @click="followSender(index, item.index_id)" />
                        <div
                          class="message-link-toSpecGroup"
                          @click="toSpecGroup(item.senderIdOrigin)"
                          style="display: inline-block"
                        >
                          <span class="groupMemberName">
                            {{item.groupMemberName}}
                          </span>
                          </div>
                            <Icon type="ios-people" color="orange" size="24" v-if="item.groupFollowed" style="cursor: pointer;" @click="cancelFollowQun(index, item.index_id)"/>
                            <Icon type="ios-people-outline" color="orange" size="24" style="cursor: pointer;" v-else @click="followQun(index, item.index_id)"/>
                            <div
                          class="message-link-toSpecGroup"
                          @click="toSpecGroup(item.senderIdOrigin)"
                          style="display: inline-block"
                        >
                          <span class="groupNum">
                            {{item.groupNum}}
                          </span>
                          </div>
                        

                        <span class="messageTime">{{item.date}} {{item.time}}</span>
                      </div>
                      <div class="message-content" v-html="item.messageContent"></div>
                      <div class="message-footer">
                        <span class="message-key" v-if="item.eventKeyWord">
                          关键词：{{ item.eventKeyWord }}
                        </span>
                        <span class="message-key-type" v-if="item.eventTypeWord">
                          敏感分类：{{ item.eventTypeWord }}
                        </span>
                        <span
                          class="checkContext"
                          :id="'checkContext-'+item.id"
                          @click="handleClickCheckContext(item.id)"
                        >查看上下文</span>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div class="page-wrapper" v-show="isShowPage">
              <Page
                :total="listMessage_total"
                :current="currentPage"
                @on-change="changePage"
                show-total
                class="page"
              />
            </div>
          </div>
          <!-- 快速分析 ------------------------------------------------------------------------------------------->
          <div class="tab-main tab-main-rapidAnalyse" v-show="!isShowContentMsgList">
            <div class="tip" v-show="isShowTip" @click="handleClickTip">
              <p>截止到{{tipInfo.currentDate}} {{tipInfo.currentTime}}，又抓取到{{tipInfo.newDataNum}}条新数据，点击刷新数据列表</p>
            </div>
            <div class="wrap-up">
              <!-- 舆情走势 -------------------------------------------------------->
              <section class="wrap-trendCharts">
                <h2 class="section-title">舆情走势</h2>
                <span class="icon-download" @click="downLoadTrendPic">下载</span>
                <loading-icon :isShowLoadingIcon="isBtnDownloadDisabled_trend"></loading-icon>
                <ul class="btnGroup">
                  <li
                    class="btnItem"
                    :class="{'isSelected':btnTrendIsActive.all}"
                    @click="handleSelectBtnTrend('all')"
                  >全部</li>
                  <li
                    class="btnItem"
                    :class="{'isSelected':btnTrendIsActive.source}"
                    @click="handleSelectBtnTrend('source')"
                  >来源分类</li>
                  <li
                    class="btnItem"
                    :class="{'isSelected':btnTrendIsActive.emotions}"
                    @click="handleSelectBtnTrend('emotions')"
                  >情感分类</li>
                </ul>
                <div class="charts-wrapper">
                  <div
                    ref="charts_line_total"
                    class="charts_line_total"
                    v-show="btnTrendIsActive.all"
                  ></div>
                  <div
                    ref="charts_line_source"
                    class="charts_line_source"
                    v-show="btnTrendIsActive.source"
                  ></div>
                  <div
                    ref="charts_line_emotions"
                    class="charts_line_emotions"
                    v-show="btnTrendIsActive.emotions"
                  ></div>
                </div>
              </section>
              <!-- 词云分析 -------------------------------------------------------->
              <section class="wrap-wordCloudCharts">
                <h2 class="section-title">词云分析</h2>
                <span class="icon-download" @click="downLoadWordCloudPic">下载</span>
                <loading-icon :isShowLoadingIcon="isBtnDownloadDisabled_wordCloud"></loading-icon>
                <div class="charts-wrapper">
                  <div ref="charts_wordCloud" class="charts_wordCloud"></div>
                </div>
                <footer class="wordCloud-footer">
                  <span class="wordCloud-legend legend-positive">非负面</span>
                  <span class="wordCloud-legend legend-negative">负面</span>
                </footer>
              </section>
            </div>
            <div class="wrap-down">
              <!-- 群组监测 -------------------------------------------------------->
              <section class="wrap-groupSpecTable">
                <h2 class="section-title">群组监测</h2>
                <table cellspacing="0" cellpadding="0" border="0" class="table">
                  <thead class="table-head">
                    <tr align="center">
                      <th>群组</th>
                      <th>预警量</th>
                      <th>消息总量</th>
                      <th>预警比例</th>
                    </tr>
                  </thead>
                  <tbody class="table-body">
                    <tr v-for="(item,i) in table_groupSpecData" :key="i">
                      <td>{{item.name}}</td>
                      <td>{{item.alertAmount}}</td>
                      <td>{{item.total}}</td>
                      <td>{{item.alertRatio}}</td>
                    </tr>
                  </tbody>
                </table>
              </section>
              <!-- 群组活跃用户监测 -------------------------------------------------------->
              <div class="wrap-groupActiveUserSpecTable">
                <h2 class="section-title">群组活跃用户监测</h2>
                <table cellspacing="0" cellpadding="0" border="0" class="table">
                  <thead class="table-head">
                    <tr align="center">
                      <th>用户</th>
                      <th>参与群组</th>
                      <th>总发言</th>
                      <th>预警数</th>
                    </tr>
                  </thead>
                  <tbody class="table-body">
                    <tr v-for="(item,i) in table_activeUserSpecData" :key="i">
                      <td>{{item.sendMsgName}}</td>
                      <td>{{item.diffGroupNum}}</td>
                      <td>{{item.totalCount}}</td>
                      <td>{{item.warningCount}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </Col>
    </Row>
    <!-- 模态框------------------------------------------------------------------>
    <dialog-context
      ref="dialogContext"
      :currentMsgId="currentMsgId"
      :dialogGroupName="dialogGroupName"
    ></dialog-context>
    <!-- loading动画 --------------------------------------------------------------------------->
    <loading
      :isLoading="isLoading_msgList||isLoading_rapidAnalyse_trends||isLoading_rapidAnalyse_wordCloud||isLoading_rapidAnalyse_tables"
    ></loading>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // 公共模块+舆情走势模块------------------------------------------------------------------//
      //是否展示<舆情列表>
      isShowContentMsgList: true,
      //是否正在加载消息列表数据
      isLoading_msgList: false,
      //任务列表
      taskList: [],
      //过滤后的任务列表数据
      taskList_search: [],
      //tabHeader是否吸顶
      isTabHeaderStick: false,
      //当前选中的任务id
      currentTaskId: "",
      //当前选中的消息id
      currentMsgId: "",
      //<发布时间>过滤按钮选中的时间--1:今天,3:近三天,7:近七天,30:近30天,'custom':自定义
      timeSelected: 1,
      //控制<datePicker>的显示
      isShowDatePicker: false,
      //<datePicker>的绑定的值
      dateRange: [],
      //消息列表统计数量标签的数据
      dataNum: {
        //总量
        total: 0,
        //预警量
        warning: 0,
        //预警量-非负面
        positive: 0,
        //预警量-负面
        negative: 0
      },
      //更新消息tip的数据
      tipInfo: {
        currentDate: 0,
        currentTime: 0,
        newDataNum: 0
      },
      //消息列表的所有数据
      listMessage: [],
      //消息列表的总数据数目
      listMessage_total: 0,
      //当前展示的页码
      currentPage: 1,
      //是否展示分页：没有数据时隐藏
      isShowPage: true,
      //控制显示tip
      isShowTip: false,
      //每隔五分钟更新tip
      timer: null,
      //群对话记录模态框群名称
      dialogGroupName: "",
      //记录上一次刷新数据时间
      lastRefreshTime: -1,
      //消息列表数据查询条件
      queryData: {
        jobId: "",
        startTime: -1,
        endTime: -1,
        groupName: "",
        keyWords: "",
        feeling: "",
        pageNum: 1,
        pageSize: 10,
        isWarn: 1
      },
      //是否具有消息列表查看权限
      enable_list: false,
      // 快速分析模块------------------------------------------------------------------//
      //是否具有快速分析查看权限
      enable_analyze: false,
      //控制快速分析模块舆情走势数据加载
      isLoading_rapidAnalyse_trends: false,
      //控制快速分析模块词云数据加载
      isLoading_rapidAnalyse_wordCloud: false,
      //控制快速分析模块群组表格的数据加载
      isLoading_rapidAnalyse_tables: false,
      //控制<舆情走势>的tab按钮
      btnTrendIsActive: {
        all: true,
        source: false,
        emotions: false
      },
      //记录每一个图表的dataUrl
      echartsDataUrl: {
        url_trend_all: "", //舆情走势--全部
        url_trend_source: "", //舆情走势--来源分类
        url_trend_emotions: "", //舆情走势--情感分类
        url_wordCloud: "" //词云分析
      },
      //<舆情走势>的下载按钮是否禁用
      isBtnDownloadDisabled_trend: true,
      //<词云分析>的下载按钮是否禁用
      isBtnDownloadDisabled_wordCloud: true,
      //<舆情走势>模块数据
      sentimentTrendData: {
        xData: [],
        charts_all: [],
        charts_source: {
          data_legend: [],
          data_y: []
        },
        charts_emotion: {
          data_legend: [],
          data_y: []
        }
      },
      //<词云分析>模块数据
      wordCloudData: [],
      //<群组监测>表格数据
      table_groupSpecData: [],
      //<群组活跃用户监测>表格数据
      table_activeUserSpecData: []
    };
  },
  mounted() {
    //为侧边栏添加吸顶效果
    this.tabHeaderStickToTop();
    //获取消息列表和快速分析权限
    this.getAuthorities();
  },
  destroyed() {
    //销毁vm实例后，解除滚动绑定事件
    this.removeScrollEvent();
  },
  methods: {
    //公共模块+舆情列表模块------------------------------------------------------------------//
    //切换舆情列表和快速分析视图
    changeView(param){
      if(param===0){
        //舆情列表
        if(this.enable_list){
          this.isShowContentMsgList = true;
        }else{
          this.$Message.error('未获得查看该模块权限');
        }
      }else{
        //快速分析
        if(this.enable_analyze){
          this.isShowContentMsgList = false;
        }else{
          this.$Message.error('未获得查看该模块权限');
        }
      }
    },
    //获取消息列表和快速分析权限
    getAuthorities() {
      let authorites = this.getLocalStorage("authorities").split(",");
      this.enable_list = authorites.includes("group_list");
      this.enable_analyze = authorites.includes("group_analyze");
    },
    //为tabHeader添加吸顶功能
    tabHeaderStickToTop() {
      this.$nextTick(() => {
        window.addEventListener("scroll", this.addScrollEvent, false);
      });
    },
    //给window绑定滚动事件
    addScrollEvent(e) {
      let scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      if (scrollTop > 390) {
        this.isTabHeaderStick = true;
      } else {
        this.isTabHeaderStick = false;
      }
    },
    //给window解除滚动事件
    removeScrollEvent() {
      window.removeEventListener("scroll", this.addScrollEvent);
    },
    //点击<任务列表>的任务
    handleSelectTask(id) {
      //更新当前所选任务id和过滤条件中的任务id
      this.currentTaskId = this.queryData.jobId = id;
      //初始化所有过滤条件
      this.initAll();
      //销毁之前任务的定时器
      clearInterval(this.timer);
      this.timer = null;
      //获取消息列表数据,舆情走势数据,词云分析数据,群组表格数据
      this.getData_msg_trends_wordCloud_tables();
    },
    //获取消息列表数据
    getMessageListData(isFromTip = false) {
      if (this.isLoading_msgList) return;
      this.isLoading_msgList = true;
      //jobId不能为空
      if (this.queryData.jobId === "") {
        this.isLoading_msgList = false;
        return;
      }
      //如果点击了tip，则需要更新queryData.endTimeMs为点击tip的时间
      if (isFromTip) {
        this.queryData.endTime = new Date().getTime();
      }
      //发送ajax请求
      this.$ajax({
        method: "get",
        url: "./sentiment/groupMsgData/msgList",
        params: this.queryData
      })
        .then(res => {
          this.isLoading_msgList = false;
          if (res.data.success) {
            if (res.data.data) {
              //先清空listMessage中的数据
              this.listMessage = [];
              //更新消息总数和统计数据
              //tag-总量
              this.dataNum.total = res.data.data.totalCount;
              //tag-预警量:页码中对应的消息数量是<预警量>，不是总量！
              this.dataNum.warning =
                res.data.data.jobDataSize || 0;
              if (this.queryData.isWarn === 0) {
                this.listMessage_total = res.data.data.jobDataSize || 0;
              } else {
                this.listMessage_total = res.data.data.totalCount || 0;
              }
              //tag-预警量-非负面
              this.dataNum.positive = res.data.data.groupDataSize
                ? res.data.data.groupDataSize["0"] || 0
                : 0;
              //tag-预警量-负面
              this.dataNum.negative = res.data.data.groupDataSize
                ? res.data.data.groupDataSize["1"] || 0
                : 0;
              let resData = res.data.data.data;
              this.isShowPage = resData.length > 0 ? true : false; //如果没有消息数为0，则隐藏分页
              resData.forEach(item => {
                this.listMessage.push({
                  id: item.index_id,
                  index_id: item.id,
                  propertyColor: item.feeling == "0" || item.feeling == "-1" ? "success" : "error",
                  propertyLabel: item.feeling == "0" || item.feeling == "-1" ? "非负面" : "负面",
                  feeling: item.feeling,
                  groupMemberName: `${item.sendMsgName}(${item.senderId})`,
                  groupMemberId: item.senderId,
                  groupNum: `${item.groupName}`,
                  messageContent:
                    item.msg.length > 80
                      ? item.msg.substring(0, 80) + "..."
                      : item.msg,
                  keyWords: item.warning_key_words,
                  date: this.formatDate(item.publishTime),
                  time: this.formatTime(item.publishTime),
                  senderIdOrigin: item.senderIdOrigin,
                  followed: item.followed,
                  senderFollwoed: item.senderFollwoed,
                  groupFollowed: item.groupFollowed
                });
              });
              //根据搜索框中关键词标记文本中的关键词
              this.markKeywords();
              //记录本次刷新的时间
              this.lastRefreshTime = new Date().getTime();
              //销毁之前的tip定时器
              clearInterval(this.timer);
              this.timer = null;
              //重新开始tip定时器
              this.openTipTimer();
            }
          } else {
            if (res.data.code !== 405) {
              this.$Message.error("服务器错误");
            }
          }
        })
        .catch(err => {
          this.isLoading_msgList = false;
          this.$Message.error("服务器错误");
          console.log(err);
        });
    },
    //获取快速分析模块舆情走势数据
    getRapidAnalyseData_trends() {
      // if (this.isLoading_rapidAnalyse_trends) return;
      // this.isLoading_rapidAnalyse_trends = true;
      //jobId不能为空
      if (this.queryData.jobId === "") {
        this.isLoading_rapidAnalyse_trends = false;
        return;
      }
      this.$ajax({
        method: "get",
        url: "./sentiment/groupMsgData/trends",
        params: this.queryData
      })
        .then(res => {
          // this.isLoading_rapidAnalyse_trends = false;
          if (res.data.success) {
            let resData = res.data.data;
            //更新舆情走势x轴数据
            this.sentimentTrendData.xData = resData.dateList;
            //更新舆情走势--<全部>数据
            this.sentimentTrendData.charts_all = resData.totalTrends;
            //生成<全部>折线图
            this.generateCharts_line_all();

            //更新<来源分类>折线图数据
            this.sentimentTrendData.charts_source.data_legend = [];
            this.sentimentTrendData.charts_source.data_y = [];
            for (let prop in resData.sourceTrends) {
              this.sentimentTrendData.charts_source.data_legend.push(prop);
              this.sentimentTrendData.charts_source.data_y.push({
                name: prop,
                type: "line",
                data: resData.sourceTrends[prop],
                smooth: true
              });
            }
            //生成<来源分类>折线图
            this.generateCharts_line_source();

            //更新<情感分类>折线图数据
            this.sentimentTrendData.charts_emotion.data_legend = [];
            this.sentimentTrendData.charts_emotion.data_y = [];
            for (let prop in resData.emotionTrends) {
              this.sentimentTrendData.charts_emotion.data_legend.push(prop);
              this.sentimentTrendData.charts_emotion.data_y.push({
                name: prop,
                type: "line",
                smooth: true,
                itemStyle: {
                  normal: {
                    color: (function(prop) {
                      let color = "#44C58D";
                      switch (prop) {
                        case "非负面":
                          color = "#44C58D";
                          break;
                        case "负面":
                          color = "#FA5D5D";
                          break;
                        default:
                          break;
                      }
                      return color;
                    })(prop),
                    lineStyle: {
                      color: (function(prop) {
                        let color = "#44C58D";
                        switch (prop) {
                          case "非负面":
                            color = "#44C58D";
                            break;
                          case "负面":
                            color = "#FA5D5D";
                            break;
                          default:
                            break;
                        }
                        return color;
                      })(prop)
                    }
                  }
                },
                data: resData.emotionTrends[prop]
              });
            }
            //生成<情感分类>折线图
            this.generateCharts_line_emotions();
          } else {
            if (res.data.code !== 405) {
              this.$Message.error("服务器错误");
            }
          }
        })
        .catch(err => {
          this.isLoading_rapidAnalyse_trends = false;
          this.$Message.error("服务器错误");
          console.log(err);
        });
    },
    //获取快速分析模块词云数据
    getRapidAnalyseData_wordCloud() {
      if (this.isLoading_rapidAnalyse_wordCloud) return;
      this.isLoading_rapidAnalyse_wordCloud = true;
      //jobId不能为空
      if (this.queryData.jobId === "") {
        this.isLoading_rapidAnalyse_wordCloud = false;
        return;
      }
      let queryWordCloud = {
        jobId: this.queryData.jobId,
        startTime: this.queryData.startTime,
        endTime: this.queryData.endTime,
        showType: 1, //数据类型，默认为0, 0：所有，1：群组，2：媒体
        count: 20, //词云展示数量，默认20
        keyWords: this.queryData.keyWords, //关键词搜索条件，多个以逗号隔开（快速分析界面使用）
        feeling: this.queryData.feeling, //0:正面/非负面 1:负面 空:全部
        groupId: this.queryData.groupName
      };
      this.$ajax({
        method: "get",
        url: "./summary/keyword/result",
        params: queryWordCloud
      })
        .then(res => {
          this.isLoading_rapidAnalyse_wordCloud = false;
          if (res.data.success) {
            this.wordCloudData = [];
            let resData = res.data.data || [];
            resData.forEach(item => {
              this.wordCloudData.push({
                name: item.keyword,
                value: item.num,
                prop: item.feeling,
                textStyle: this.generateColor(parseInt(item.feeling))
              });
            });
            //生成词云图
            this.generateCharts_wordCloud();
          } else {
            if (res.data.code !== 405) {
              this.$Message.error("服务器错误");
            }
          }
        })
        .catch(err => {
          this.$Message.error("服务器错误");
          this.isLoading_rapidAnalyse_wordCloud = false;
          console.log(err);
        });
    },
    //获取快速分析模块群组表格数据
    getRapidAnalyseData_tables() {
      if (this.isLoading_rapidAnalyse_tables) return;
      this.isLoading_rapidAnalyse_tables = true;
      //jobId不能为空
      if (this.queryData.jobId === "") {
        this.isLoading_rapidAnalyse_tables = false;
        return;
      }
      this.$ajax({
        method: "get",
        url: "./sentiment/groupMsgData/groupWarning",
        params: this.queryData
      })
        .then(res => {
          this.isLoading_rapidAnalyse_tables = false;
          if (res.data.success) {
            let resData = res.data.data;
            resData.groupWarns = resData.groupWarns || [];
            resData.activeUsers = resData.activeUsers || [];
            //先清空
            this.table_groupSpecData = [];
            this.table_activeUserSpecData = [];
            //更新群组监测数据
            resData.groupWarns.forEach(item => {
              this.table_groupSpecData.push({
                name: item.groupName,
                alertAmount: item.warningCount,
                total: item.totalCount,
                alertRatio: item.percent + "%"
              });
            });
            //更新群组活跃用户监测数据
            resData.activeUsers.forEach(item => {
              this.table_activeUserSpecData.push({
                sendMsgName: item.sendMsgName,
                warningCount: item.warningCount,
                totalCount: item.totalCount,
                diffGroupNum: item.diffGroupNum
              });
            });
          } else {
            if (res.data.code !== 405) {
              this.$Message.error("服务器错误");
            }
          }
        })
        .catch(err => {
          this.$Message.error("服务器错误");
          this.isLoading_rapidAnalyse_tables = false;
          console.log(err);
        });
    },
    //初始化过滤按钮、搜索框和页码
    initAll() {
      //<发布时间>按钮样式和过滤条件数据
      this.timeSelected = 1;
      this.queryData.startTime = new Date().setHours(0, 0, 0, 0);
      this.queryData.endTime = new Date().getTime();
      //<情感分类>过滤条件数据
      this.queryData.feeling = "";
      //<关键词搜索框>文本和过滤条件数据
      this.queryData.keyWords = "";
      //<群号群名称搜索框>文本和过滤条件数据
      this.queryData.groupName = "";
      //还原页码
      this.currentPage = this.queryData.pageNum = 1;
      //隐藏datePicker
      this.isShowDatePicker = false;
      //页面回滚到最顶部
      window.scrollTo(0, 0);
      //清除吸顶效果
      this.isTabHeaderStick = false;
    },
    //切换<发布时间>按钮
    handleSelectLanchDate(params) {
      this.isShowDatePicker = false;
      this.timeSelected = params;
      //改变样式
      if (params === "custom") {
        this.isShowDatePicker = true;
      } else {
        this.isShowDatePicker = false;
        //更新搜索条件数据
        if (params === 1) {
          this.queryData.startTime = new Date().setHours(0, 0, 0, 0); //起始时间是今天0点
        } else {
          //如果不是<今天>，则倒推到(n-1)天前的0点，例如今天是15日，近3天的起始时间是13日的0点
          this.queryData.startTime =
            new Date().setHours(0, 0, 0, 0) -
            1000 * 60 * 60 * 24 * (params - 1);
        }
        this.queryData.endTime = new Date().getTime(); //终止时间是现在时刻
        //还原页码
        this.currentPage = this.queryData.pageNum = 1;
        //获取消息列表数据,舆情走势数据,词云分析数据,群组表格数据
        this.getData_msg_trends_wordCloud_tables();
      }
    },
    //点击<datePicker>的确定按钮
    confirmDatePicker() {
      //校验当前日期范围跨度是否大于90天
      let start = null;
      let end = null;
      if (this.dateRange[0] === this.dateRange[1]) {
        //如果选择的是同一天
        start = new Date(this.dateRange[0]).setHours(0, 0, 0, 0);
        end = start + 1000 * 60 * 60 * 24;
        //更新搜索条件数据
        this.queryData.startTime = start;
        this.queryData.endTime = end;
        //还原页码
        this.currentPage = this.queryData.pageNum = 1;
        //获取消息列表数据,舆情走势数据,词云分析数据,群组表格数据
        this.getData_msg_trends_wordCloud_tables();
      } else {
        start = new Date(this.dateRange[0]).setHours(0, 0, 0, 0);
        end = new Date(this.dateRange[1]).getTime() + 1000 * 60 * 60 * 24 - 1;
        let differ = end - start;
        if (differ > 1000 * 60 * 60 * 24 * 90) {
          this.$Message.error("日期范围跨度不得大于90天");
          this.dateRange = []; //清空已选日期
        } else {
          //更新搜索条件数据
          this.queryData.startTime = start;
          this.queryData.endTime = end;
          //还原页码
          this.currentPage = this.queryData.pageNum = 1;
          //获取消息列表数据,舆情走势数据,词云分析数据,群组表格数据
          this.getData_msg_trends_wordCloud_tables();
        }
      }
    },
    // 切换预警分类按钮
    handleSelectIsWarn(params) {
      this.queryData.isWarn = params;
      this.currentPage = this.queryData.pageNum = 1;
      this.getData_msg_trends_wordCloud_tables();
    },
    //切换<情感分类>按钮
    handleSelectSentiment(params) {
      //更新搜索条件数据
      this.queryData.feeling = params;
      //还原页码
      this.currentPage = this.queryData.pageNum = 1;
      //获取消息列表数据,舆情走势数据,词云分析数据,群组表格数据
      this.getData_msg_trends_wordCloud_tables();
    },
    //搜索<关键词>搜索框
    searchByKeyWords() {
      //替换中文逗号为英文逗号
      this.queryData.keyWords = this.queryData.keyWords.replace(/，/g, ",");
      //还原页码
      this.currentPage = this.queryData.pageNum = 1;
      //获取消息列表数据,舆情走势数据,词云分析数据,群组表格数据
      this.getData_msg_trends_wordCloud_tables();
    },
    //点击<群号/名称>搜索按钮
    searchByGroupNumOrName() {
      //还原页码
      this.currentPage = this.queryData.pageNum = 1;
      //获取消息列表数据,舆情走势数据,词云分析数据,群组表格数据
      this.getData_msg_trends_wordCloud_tables();
    },
    //获取消息列表数据,舆情走势数据,词云分析数据,群组表格数据
    getData_msg_trends_wordCloud_tables() {
      //获取消息列表数据
      this.getMessageListData();
      //获取快速分析--舆情走势数据
      this.getRapidAnalyseData_trends();
      //获取快速分析--词云分析数据
      this.getRapidAnalyseData_wordCloud();
      //获取快速分析--群组表格数据
      this.getRapidAnalyseData_tables();
    },
    //切换页码
    changePage(page) {
      //更新页码
      this.currentPage = this.queryData.pageNum = page;
      //查询舆情列表数据
      this.getMessageListData();
    },
    //开启tip定时器，每五分钟获取一次新数据
    openTipTimer() {
      this.timer = setInterval(() => {
        this.getNewTip();
      }, 1000 * 60 * 5);
    },
    //点击<tip>更新列表
    handleClickTip() {
      this.isShowTip = false;
      this.getMessageListData(true);
      this.getRapidAnalyseData_trends();
      this.getRapidAnalyseData_wordCloud();
      this.getRapidAnalyseData_tables();
    },
    //每隔5分钟自动更新<tip>信息
    getNewTip() {
      //jobId不能为空
      if (this.queryData.jobId === "") return;
      let tipQueryData = Object.assign({}, this.queryData);
      tipQueryData.startTime = this.lastRefreshTime;
      tipQueryData.endTime = new Date().getTime();
      this.$ajax({
        method: "get",
        url: "./sentiment/groupMsgData/msgList",
        params: tipQueryData
      })
        .then(res => {
          if (res.data.success) {
            if (res.data.data) {
              //更新<抓取的新数据>
              this.tipInfo.newDataNum = res.data.data.jobDataSize || 0;
              //更新<截止到xx时间>
              let byTime = new Date(this.lastRefreshTime);

              this.tipInfo.currentDate = this.formatDate(byTime);
              this.tipInfo.currentTime = this.formatTime(byTime);
              //如果从未显示过tip，那么直到抓取到新数据时才显示tip，否则不显示
              if (!this.isShowTip) {
                if (this.tipInfo.newDataNum !== 0) {
                  this.isShowTip = true;
                }
              }
            }
          } else {
            if (res.data.code !== 405) {
              this.$Message.error("服务器错误");
            }
          }
        })
        .catch(err => {
          this.$Message.error("服务器错误");
          //console.log(err);
        });
    },
    //点击qq/微信群跳转到成员发言记录页面
    toSpecGroup(groupMemberId) {
      let routeData = this.$router.resolve({
        path: "./groupSpec_group",
        query: {
          senderId: groupMemberId,
          jobId: this.currentTaskId
        }
      });
      window.open(routeData.href, "_blank");
    },
    flowMessage(index,id){
      this.$ajax({
        method: "get",
        url: "./focusOn/focusAll",
        params: {
          "id": id
        }
      })
      .then(res => {
        if (res.data.success) {
          if (res.data.data) {
            this.$Message.success("关注成功")
          } else {
            this.$Message.error("关注失败")
          }
        }
      })
      .catch(err => {
        this.$Message.error("服务器错误");
          //console.log(err);
      });

      //debugger;
      if(this.listMessage[index].followed){
        this.listMessage[index].followed = false;
      }
      else{
        this.listMessage[index].followed = true;
      }
      this.$set(this.listMessage, index, this.listMessage[index])
      //console.log(index,this.listMessage[index],this.listMessage[index].followed);
    },

    cancelFlowMeaasge(index,id) {
      this.$ajax({
        method: "get",
        url: "./focusOn/cancelFocusAll",
        params: {
          "id": id
        }
      })
      .then(res => {
        if (res.data.success) {
          if (res.data.data) {
            this.$Message.success("取消关注成功")
          } else {
            this.$Message.error("取消关注失败")
          }
        }
      })
      .catch(err => {
        this.$Message.error("服务器错误");
          console.log(err);
      });

      //debugger;
      if(this.listMessage[index].followed){
        this.listMessage[index].followed = false;
      }
      else{
        this.listMessage[index].followed = true;
      }
      this.$set(this.listMessage, index, this.listMessage[index])
      console.log(index,this.listMessage[index],this.listMessage[index].followed);
    },

    cancelFollowSender(index, id) {
      this.$ajax({
         method: "get",
         url: "./focusOn/cancelFocus",
         params: {
          "id": id,
          "type": 1
         }
      })
      .then(res => {
        if (res.data.success) {
          if (res.data.data) {
            this.$Message.success("取消关注成功")
          } else {
            this.$Message.error("取消关注失败")
          }
        }
      })
      .catch(err => {
        this.$Message.error("服务器错误");
        console.log(err);
      });

      if(this.listMessage[index].senderFollwoed){
        this.listMessage[index].senderFollwoed = false;
      }
      else{
        this.listMessage[index].senderFollwoed = true;
      }
      this.$set(this.listMessage, index, this.listMessage[index])
      console.log(index,this.listMessage[index],this.listMessage[index].senderFollwoed);

    },
    followSender(index, id) {
      this.$ajax({
        method: "get",
        url: "./focusOn/setFocus",
        params: {
          "id": id,
          "type": 1
        }
      })
      .then(res => {
        if (res.data.success) {
          if (res.data.data) {
            this.$Message.success("关注成功")
          } else {
            this.$Message.error("关注失败")
          }
        }
      })
      .catch(err => {
        this.$Message.error("服务器错误");
        console.log(err);
      });

      if(this.listMessage[index].senderFollwoed){
        this.listMessage[index].senderFollwoed = false;
      }
      else{
        this.listMessage[index].senderFollwoed = true;
      }
      this.$set(this.listMessage, index, this.listMessage[index])
      console.log(index,this.listMessage[index],this.listMessage[index].senderFollwoed);

    },
    cancelFollowQun(index, id) {
      this.$ajax({
        method: "get",
         url: "./focusOn/cancelFocus",
         params: {
          "id": id,
          "type": 0
         }
      })
      .then(res => {
        if (res.data.success) {
          if (res.data.data) {
            this.$Message.success("取消关注成功")
          } else {
            this.$Message.error("取消关注失败")
          }
        }
      })
      .catch(err => {
        this.$Message.error("服务器错误");
        console.log(err);
      });

      if(this.listMessage[index].groupFollowed){
        this.listMessage[index].groupFollowed = false;
      }
      else{
        this.listMessage[index].groupFollowed = true;
      }
      this.$set(this.listMessage, index, this.listMessage[index])
      console.log(index,this.listMessage[index],this.listMessage[index].groupFollowed);

    },

    followQun(index, id) {
      this.$ajax({
        method: "get",
        url: "./focusOn/setFocus",
        params: {
          "id": id,
          "type": 0
        }
      })
      .then(res => {
        if (res.data.success) {
          if (res.data.data) {
            this.$Message.success("关注成功")
          } else {
            this.$Message.error("关注失败")
          }
        }
      })
      .catch(err => {
        this.$Message.error("服务器错误");
        //console.log(err);
      });

      if(this.listMessage[index].groupFollowed){
        this.listMessage[index].groupFollowed = false;
      }
      else{
        this.listMessage[index].groupFollowed = true;
      }
      this.$set(this.listMessage, index, this.listMessage[index])
      //console.log(index,this.listMessage[index],this.listMessage[index].groupFollowed);

    },
    //点击<查看上下文>按钮
    handleClickCheckContext(id) {
      //更新当前选中的消息id
      this.currentMsgId = id;
      //获取该信息数据
      let messageData = this.listMessage.filter(item => item.id === id)[0];
      //更新群名称和群号码
      this.dialogGroupName = messageData.groupNum.trim();
      //初始化模态框s
      this.$nextTick(() => {
        this.$refs.dialogContext.showDialog();
      });
    },
    //关键词查找完成后，标红文本中相应的关键词
    markKeywords() {
      let arr_keyWords = this.queryData.keyWords.split("，");
      for (let i = 0; i < this.listMessage.length; i++) {
        for (let j = 0; j < arr_keyWords.length; j++) {
          this.listMessage[i].messageContent = this.listMessage[
            i
          ].messageContent
            .split(arr_keyWords[j])
            .join(`<mark style="color:red">${arr_keyWords[j]}</mark>`);
        }
      }
    },
    //快速分析模块------------------------------------------------------------------//
    //切换<舆情走势>的tab按钮
    handleSelectBtnTrend(params) {
      this.btnTrendIsActive.all = this.btnTrendIsActive.source = this.btnTrendIsActive.emotions = false;
      this.btnTrendIsActive[params] = true;
    },
    //点击<舆情走势图表>的下载按钮
    downLoadTrendPic() {
      if (this.isBtnDownloadDisabled_trend) return;
      let url = "";
      let picTitle = "";
      if (this.btnTrendIsActive.all) {
        picTitle = "舆情走势(全部).png";
        url = this.echartsDataUrl.url_trend_all;
      } else if (this.btnTrendIsActive.source) {
        picTitle = "舆情走势(来源分类).png";
        url = this.echartsDataUrl.url_trend_source;
      } else if (this.btnTrendIsActive.emotions) {
        picTitle = "舆情走势(情感分类).png";
        url = this.echartsDataUrl.url_trend_emotions;
      }
      let a = document.createElement("a");
      a.setAttribute("href", url);
      a.setAttribute("download", picTitle);
      a.click();
    },
    //点击<词云分析>的下载按钮
    downLoadWordCloudPic() {
      if (this.isBtnDownloadDisabled_wordCloud) return;
      let a = document.createElement("a");
      a.setAttribute("href", this.echartsDataUrl.url_wordCloud);
      a.setAttribute("download", "词云分析.png");
      a.click();
    },
    //生成<舆情走势>折线图--全部
    generateCharts_line_all() {
      this.isBtnDownloadDisabled_trend = true;
      let myChart = this.echarts.init(this.$refs.charts_line_total);
      let option = {
        xAxis: {
          type: "category",
          data: this.sentimentTrendData.xData //x轴数据
        },
        yAxis: {
          type: "value"
        },
        grid: {
          top: "2%",
          left: "1%",
          right: "1%",
          bottom: "1%",
          containLabel: true
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985"
            }
          }
        },
        series: [
          {
            name: "全部",
            data: this.sentimentTrendData.charts_all,
            itemStyle: {
              normal: {
                color: "#4CB6FF",
                lineStyle: {
                  color: "#4CB6FF"
                }
              }
            },
            smooth: true,
            type: "line"
          }
        ]
      };
      myChart.setOption(option, true);
      setTimeout(() => {
        this.echartsDataUrl.url_trend_all = myChart.getDataURL({
          pixelRatio: 2,
          backgroundColor: "#fff"
        });
        this.isBtnDownloadDisabled_trend = false;
      }, 2000);
    },
    //生成折线图--来源分类
    generateCharts_line_source() {
      this.isBtnDownloadDisabled_trend = true;
      let myChart = this.echarts.init(this.$refs.charts_line_source);
      let option = {
        tooltip: {
          trigger: "axis"
        },
        legend: {
          data: this.sentimentTrendData.charts_source.data_legend, //所有来源的legend名称
          y: "360px"
        },
        grid: {
          top: "6%",
          left: "3%",
          right: "4%",
          bottom: "10%",
          containLabel: true
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.sentimentTrendData.xData //x轴数据
        },
        yAxis: {
          type: "value"
        },
        series: this.sentimentTrendData.charts_source.data_y
      };
      myChart.setOption(option, true);
      setTimeout(() => {
        this.echartsDataUrl.url_trend_source = myChart.getDataURL({
          pixelRatio: 2,
          backgroundColor: "#fff"
        });
        this.isBtnDownloadDisabled_trend = false;
      }, 2000);
    },
    //生成折线图--情感分类
    generateCharts_line_emotions() {
      this.isBtnDownloadDisabled_trend = true;
      let myChart = this.echarts.init(this.$refs.charts_line_emotions);
      let option = {
        tooltip: {
          trigger: "axis"
        },
        legend: {
          data: this.sentimentTrendData.charts_emotion.data_legend, //所有来源的legend名称
          y: "360px"
        },
        grid: {
          top: "6%",
          left: "3%",
          right: "4%",
          bottom: "10%",
          containLabel: true
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.sentimentTrendData.xData //x轴数据
        },
        yAxis: {
          type: "value"
        },
        series: this.sentimentTrendData.charts_emotion.data_y
      };
      myChart.setOption(option, true);
      setTimeout(() => {
        this.echartsDataUrl.url_trend_emotions = myChart.getDataURL({
          pixelRatio: 2,
          backgroundColor: "#fff"
        });
        this.isBtnDownloadDisabled_trend = false;
      }, 2000);
    },
    //生成词云
    generateCharts_wordCloud() {
      this.isBtnDownloadDisabled_wordCloud = true;
      let myChart = this.echarts.init(this.$refs.charts_wordCloud);
      let option = {
        tooltip: {
          show: true
        },
        series: [
          {
            name: "词云分析",
            type: "wordCloud",
            size: ["95%", "95%"],
            sizeRange: [40, 80],
            rotationRange: [0, 0],
            textPadding: 0,
            autoSize: {
              enable: true,
              minSize: 14
            },
            data: this.wordCloudData
          }
        ]
      };

      myChart.setOption(option, true);
      setTimeout(() => {
        this.echartsDataUrl.url_wordCloud = myChart.getDataURL({
          pixelRatio: 2,
          backgroundColor: "#fff"
        });
        this.isBtnDownloadDisabled_wordCloud = false;
      }, 2000);
    },
    //根据词云的情感生成颜色
    generateColor(prop) {
      let obj = {
        normal: {
          color: ""
        }
      };
      switch (prop) {
        //正面
        case 2:
          obj.normal.color = "#44C58D";
          break;
        //中性
        case 0:
          obj.normal.color = "#44C58D";
          break;
        //负面
        case 1:
          obj.normal.color = "#FA5D5D";
          break;
        default:
          break;
      }
      return obj;
    }
  }
};
</script>

<style lang="less">
@import "../../../style/common.less";
#page-groupSpec {
  // 公共类----------------------------------------------------------------------//
  ul {
    list-style-type: none;
  }
  .main {
    width: 1160px;
    margin: 20px auto !important;
  }
  .option-title {
    line-height: 35px;
    font-family: PingFangSC-Regular;
    font-size: 16px;
    color: #666666;
    letter-spacing: -0.33px;
    margin-right: 16px;
  }

  #rightSide {
    min-height: 1000px;
  }

  .buttonGroup-item {
    float: left;
    width: 103px;
    line-height: 38px;
    border: 1px solid #ddd;
    height: 40px;
    font-family: PingFangSC-Regular;
    font-size: 14px;
    color: #333333;
    letter-spacing: -0.29px;
    cursor: pointer;
    transition: all 0.2s ease-in-out;
  }
  .buttonGroup-item:first-child {
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
  }
  .buttonGroup-item:last-child {
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
  }
  .active {
    background-color: #415af6;
    color: #fff;
  }

  .input-search {
    float: left;
    input {
      height: 35px;
      font-size: 14px;
      color: #333;
    }
  }
  // 公共类----------------------------------------------------------------------//
  .aside {
    background-color: #fff;
    padding: 35px 0;
    h5 {
      font-family: PingFangSC-Medium;
      font-size: 20px;
      color: #333333;
      letter-spacing: -0.41px;
      text-align: left;
      padding-left: 30px;
    }
    .taskList {
      margin-top: 20px;
      .taskList-item {
        height: 47px;
        line-height: 47px;
        font-family: PingFangSC-Regular;
        font-size: 18px;
        color: #333333;
        letter-spacing: -0.37px;
        text-align: left;
        padding-left: 30px;
        cursor: pointer;
        transition: all 0.2s ease-in-out;
      }
      .item-selected {
        background-color: rgb(214, 217, 247);
        color: #415af6;
      }
    }
  }

  .content-up {
    background-color: #fff;
    width: 944px;
    padding: 30px 0;
    .row-launchDate {
      position: relative;
      .buttonGroup {
        height: 35px;
        width: 525px;
      }
      .datePicker {
        position: absolute;
        right: 0;
        top: 0;
        width: 200px;
        margin-right: 100px;
        top: 50%;
        transform: translateY(-50%);
        z-index: 999;
      }
    }
  }

  .content-down {
    background-color: #fff;
    margin-top: 16px;
    padding: 0 23px 50px 23px;
    width: 944px;
    .tab-header {
      height: 59px;
      border-bottom: 1px solid #efeff4;
      position: relative;
      .tab-title {
        float: left;
        width: 75px;
        height: 60px;
        line-height: 60px;
        font-family: PingFangSC-Medium;
        font-size: 18px;
        color: #333333;
        margin-right: 64px;
        cursor: pointer;
        &.disabled {
          color: #999;
          cursor: not-allowed;
        }
        &.tab-title-selected {
          border-bottom: 3px solid #415af6;
        }
      }
      .dataNum-wrapper {
        position: absolute;
        right: 0;
        padding: 18px 0;
        overflow: hidden;
        height: 100%;
        box-sizing: border-box;
        margin-right: 23px;
        .tag-dataNum {
          float: left;
          margin-left: 20px;
          font-family: PingFangSC-Regular;
          font-size: 14px;
          color: #ffffff;
        }
      }
    }
    .tab-header-stick {
      position: fixed;
      top: 0;
      height: 59px;
      width: 898px;
      background-color: #fff;
      z-index: 999;
    }
    .tab-header-placeholder {
      position: fixed;
      height: 0;
      width: 0;
    }
    .tab-header-placeholder-active {
      position: static;
      height: 59px;
      width: 898px;
      opacity: 1;
    }
    .tab-main-msgList {
      .tab-content {
        .tip {
          margin: 20px 0 10px 0;
          p {
            padding-left: 5px;
            height: 30px;
            line-height: 30px;
            text-align: left;
            background-color: #fffcdd;
            font-family: PingFangSC-Regular;
            font-size: 14px;
            color: #ffa810;
            cursor: pointer;
          }
          p:hover {
            opacity: 0.8;
          }
        }
        .listMessage-wrapper {
          margin-top: 20px;
          .listMessage {
            .listMessage-item {
              overflow: hidden;
              margin-bottom: 10px;
              .ls {
                float: left;
              }
              .rs {
                float: left;
                width: 800px;
                padding-left: 15px;
                .message-title {
                  text-align: left;
                  .message-link-toSpecGroup {
                    display: inline-block;
                    border-bottom: 2px solid #fff;
                    cursor: pointer;
                    box-sizing: border-box;
                    .groupMemberName {
                      font-family: PingFangSC-Medium;
                      font-size: 16px;
                      color: #415af6;
                      letter-spacing: 0;
                      line-height: 24px;
                    }
                    .groupNum {
                      font-family: PingFangSC-Medium;
                      font-size: 16px;
                      color: #415af6;
                      letter-spacing: 0;
                      line-height: 24px;
                      margin-left: 15px;
                    }
                  }
                  .messageTime {
                    float: right;
                    font-family: PingFangSC-Regular;
                    font-size: 14px;
                    color: #c8c7cc;
                    letter-spacing: 0;
                    line-height: 26px;
                  }
                  .message-link-toSpecGroup:hover {
                    box-sizing: border-box;
                    border-bottom: 2px solid #415af6;
                  }
                }
                .message-content {
                  margin-top: 8px;
                  font-family: PingFangSC-Regular;
                  font-size: 14px;
                  color: #666666;
                  letter-spacing: 0;
                  text-align: left;
                  line-height: 22px;
                }
                .message-footer {
                  overflow: hidden;
                  height: 20px;
                  .message-key {
                    float: left;
                    margin-right: 15px;
                  }
                  .message-key-type {
                    float: left;
                    margin-right: 15px;
                  }
                  .checkContext {
                    float: right;
                    font-family: PingFangSC-Regular;
                    font-size: 14px;
                    color: #415af6;
                    letter-spacing: 0;
                    line-height: 14px;
                    text-decoration: underline;
                    display: none;
                    cursor: pointer;
                  }
                }
              }
            }
            .listMessage-item:hover .checkContext {
              display: block !important;
            }
          }
        }
      }
      .page-wrapper {
        margin-top: 40px;
        .page;
      }
    }
    .tab-main-rapidAnalyse {
      .tip {
        margin: 20px 0 10px 0;
        p {
          padding-left: 5px;
          height: 30px;
          line-height: 30px;
          text-align: left;
          background-color: #fffcdd;
          font-family: PingFangSC-Regular;
          font-size: 14px;
          color: #ffa810;
          cursor: pointer;
        }
        p:hover {
          opacity: 0.8;
        }
      }
      .section-title {
        text-align: left;
        font-family: PingFangSC-Medium;
        font-size: 24px;
        color: #333333;
        letter-spacing: 0;
      }
      .wrap-up {
        height: 484px;
        width: 895px;
        margin-top: 30px;
        display: flex;
        justify-content: space-between;
        .icon-download {
          width: 66px;
          height: 22px;
          line-height: 22px;
          border: 1px solid #415af6;
          color: #415af6;
          border-radius: 11px;
          position: absolute;
          text-align: right;
          padding-right: 12px;
          top: 5px;
          right: 0;
          cursor: pointer;
          &::before {
            content: "";
            position: absolute;
            top: 50%;
            left: 12px;
            transform: translate(0, -50%);
            display: inline-block;
            background: url("https://static.rong360.com/upload/png/95/75/95756aa6fad3be38a4101f5ae0c3dee7.png");
            height: 14px;
            width: 10px;
            .pic;
          }
          &:hover {
            opacity: 0.8;
          }
        }
        .wrap-trendCharts {
          height: 484px;
          width: 431px;
          position: relative;
          .btnGroup {
            margin-top: 35px;
            width: 240px;
            height: 22px;
            cursor: pointer;
            user-select: none;
            .btnItem {
              width: 80px;
              color: #415af6;
              font-family: PingFangSC-Regular;
              font-size: 14px;
              height: 22px;
              line-height: 22px;
              border: 1px solid #415af6;
              border-left: none;
              float: left;
              transition: all 0.2s ease-in-out;
              &:hover {
                opacity: 0.8;
              }
            }
            .btnItem:first-child {
              border-left: 1px solid #415af6;
              border-radius: 3px 0 0 3px;
            }
            .btnItem:last-child {
              border-radius: 0 3px 3px 0;
            }
            .isSelected {
              background-color: #415af6;
              color: #fff;
            }
          }
          .charts-wrapper {
            height: 385px;
            width: 431px;
            .charts_line_total,
            .charts_line_source,
            .charts_line_emotions {
              height: 385px;
              width: 431px;
              margin-top: 18px;
            }
          }
        }
        .wrap-wordCloudCharts {
          height: 492px;
          width: 426px;
          position: relative;
          .charts-wrapper {
            height: 421px;
            width: 426px;
            margin-top: 35px;
            border: 1px solid #d8d8d8;
          }
          .charts_wordCloud {
            height: 400px;
            width: 426px;
          }
          .wordCloud-footer {
            position: absolute;
            bottom: 0;
            height: 80px;
            width: 100%;
            display: flex;
            justify-content: center;
            .wordCloud-legend {
              font-family: PingFangSC-Regular;
              font-size: 12px;
              color: #666666;
              line-height: 80px;
            }
            .legend-positive {
              margin-right: 30px;
              &::before {
                content: "";
                display: inline-block;
                height: 10px;
                width: 10px;
                border-radius: 50%;
                background-color: #44c58d;
                margin-right: 6px;
              }
            }
            .legend-middle {
              margin: 0 30px;
              &::before {
                content: "";
                display: inline-block;
                height: 10px;
                width: 10px;
                border-radius: 50%;
                background-color: #ffa810;
                margin-right: 6px;
              }
            }
            .legend-negative {
              &::before {
                content: "";
                display: inline-block;
                height: 10px;
                width: 10px;
                border-radius: 50%;
                background-color: #fa5d5d;
                margin-right: 6px;
              }
            }
          }
        }
      }
      .wrap-down {
        height: 502px;
        width: 895px;
        display: flex;
        justify-content: space-between;
        .table;
        margin-top: 45px;
        .wrap-groupSpecTable {
          height: 484px;
          width: 431px;
          position: relative;
        }
        .wrap-groupActiveUserSpecTable {
          height: 484px;
          width: 426px;
          position: relative;
        }
      }
    }
  }
}
</style>
